/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { Box, Grid } from '@mui/material';
// import MediaPreview from './MediaPreview';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ReactPlayer from 'react-player';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FeedFullView from '../../FeedFullView';
import ReactDOM from 'react-dom';
import MediaPreview from './MediaPreview';
import { feedActionContext } from '../../../..';
// document viewing is not used in this component as it is currently displaying as boxes at the top of feed
const FeedMediaView = ({ mediaData, limit, smallIcons = false, feed, handleUpdateFeed = () => {}, from = '' }) =>
{
	const [ currentIndex, setCurrentIndex ] = useState(0);
	const { handleFeedAction } = useContext(feedActionContext);

	// Filter media based on the limit prop
	const visibleMedia = mediaData.slice(0, limit);
	const [ open, setOpen ] = useState<boolean>(false);
	const videoRefs = useRef<any>([]);

	// Function to handle click on media
	const handleMediaClick = (index:any) =>
	{
		setCurrentIndex(index);
		setOpen(true);
		if (from !== 'repost')
		{
			handleFeedAction('append', 'is_full_screen', true);
		}
	};

	const [ preLoad, setPreLoad ] = useState<boolean>(false);
	const lastElementRef = useRef(null);

	const PlayIcon = () =>
	{
		return (
			<Box
				sx={{
					position       : 'absolute',
					top            : 'var(--percent50)',
					left           : 'var(--percent50)',
					transform      : 'translate(-50%, -50%)',
					zIndex         : 2,
					color          : 'white',
					pointerEvents  : 'none',
					borderRadius   : 'var(--percent100)',
					background     : 'rgba(0, 0, 0, 0.5)',
					height         : 'var(--pixel40)',
					width          : 'var(--pixel40)',
					display        : 'flex',
					alignItems     : 'center',
					justifyContent : 'center'
				}}
			>
				<PlayArrowIcon sx={{ fontSize: 'var(--pixel24)' }} />
			</Box>
		);
	};

	// Function to render individual media items
	const renderMedia = (media:any, index:any) =>
	{
		const isDocument = media?.type?.match('application');
		const isImage = media?.type?.match('image');
		const isVideo = media?.type?.match('video') || media?.type === 'youtube';
		const extension = media?.key.split('.').pop();
		const docType = isDocument && [ 'doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx' ].includes(extension) ? extension : 'blank';

		return (
			<Box
				key={index}
				sx={{ position: 'relative', width: 'var(--percent100)', height: 'var(--percent100)', cursor: 'pointer' }}
				// onClick={() => handleMediaClick(index)}
				ref={lastElementRef}
			>
				{(isImage || isDocument) &&
				<Box
					component='img'
					key={media?.key}
					src={isImage
						? media?.url?.concat('?new=t')
						: isVideo
							? media?.thumbnail
							: `/documents/${docType}.png`}
					alt={media?.name}
					onClick={() => handleMediaClick(index)}
					sx={{ width        : 'var(--percent100)',
						height       : 'var(--percent100)',
						objectFit    : `${mediaData.length <= 1 ? 'contain' : 'cover'}`,
						borderRadius : '13px',
						...(isDocument ? { objectFit: 'contain', padding: 'var(--pixel10)', border: '1px solid rgba(0,0,0,0.12)' } : {})
					}}
				/>
				}
				{/* Check the media type and render accordingly */}
				{isVideo &&
				<Box
					sx={{ height: 'var(--percent100)', width: 'var(--percent100)', borderRadius: '13px', overflow: 'hidden' }}
					onClick={() => { handleMediaClick(index); }}
				>
					<ReactPlayer
						style={{ pointerEvents: 'none', width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }}
						key={media?.key}
						url={media?.url}
						playing={false}
						{...(media?.type !== 'youtube'
							? { ...(media?.thumbnail ? { light: media?.thumbnail } : {}), playIcon: <PlayIcon /> }
							: {})}
						width='var(--percent100)'
						height='var(--percent100)'
						// sx={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }}
						ref={(el) =>
						{
							if (el)
							{
								videoRefs.current[index] = el;
							}
						}}
					/>
				</Box>
				}
			</Box>
		);
	};

	useEffect(() =>
	{
		if (lastElementRef?.current)
		{
			let firstVisibleVideoFound = false;
			const observer = new IntersectionObserver(
				([ entry ]) =>
				{
					if (entry.isIntersecting)
					{
						const index = videoRefs?.current?.indexOf(entry.target);

						if (index !== -1 && !firstVisibleVideoFound)
						{
							setPreLoad(true);
							firstVisibleVideoFound = true;
						}
						// LoadMore();
						// setPreLoad(true);
					}
					else
					{
						setPreLoad(false);
					}
				},
				{
					root       : null,
					rootMargin : '0px',
					threshold  : 0.0
				}
			);

			if (lastElementRef.current)
			{
				observer.observe(lastElementRef.current);
			}

			return () =>
			{
				if (lastElementRef.current)
				{
					observer.unobserve(lastElementRef.current);
				}
			};
		}
	}, [ lastElementRef?.current ]);

	// Render media based on the number of media items
	const renderMediaItems = () =>
	{
		if (visibleMedia?.length === 1)
		{
			return renderMedia(visibleMedia[0], 0);
		}
		else if (visibleMedia?.length === 2)
		{
			return (
				<Box sx={{ display: 'flex', width: 'var(--percent100)', height: 'var(--percent100)', gap: 'var(--pixel4)' }}>
					<Box sx={{ width: '60%', height: 'var(--percent100)', marginRight: '2px' }}>
						{renderMedia(visibleMedia[0], 0)}
					</Box>
					<Box sx={{ width: '40%', height: 'var(--percent100)', display: 'flex', flexDirection: 'column' }}>
						{renderMedia(visibleMedia[1], 1)}
					</Box>
				</Box>
			);
		}
		else if (visibleMedia?.length === 3)
		{
			return (
				<Box sx={{ display: 'flex', width: 'var(--percent100)', height: 'var(--percent100)', gap: 'var(--pixel4)' }}>
					<Box sx={{ width: '60%', height: 'var(--percent100)' }}>
						{renderMedia(visibleMedia[0], 0)}
					</Box>
					<Box sx={{ width: '40%', height: 'var(--percent100)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 'var(--pixel4)' }}>
						<Box sx={{ width: 'var(--percent100)', height: '49.5%' }}>
							{renderMedia(visibleMedia[1], 1)}
						</Box>
						<Box sx={{ width: 'var(--percent100)', height: '49.5%' }}>
							{renderMedia(visibleMedia[2], 2)}
						</Box>
					</Box>
				</Box>
			);
		}
		else if (visibleMedia?.length === 4)
		{
			return (
				<Box sx={{ display: 'flex', width: 'var(--percent100)', height: 'var(--percent100)', gap: 'var(--pixel4)' }}>
					<Box sx={{ width: '60%', height: 'var(--percent100)' }}>
						{renderMedia(visibleMedia[0], 0)}
					</Box>
					<Box sx={{ width: '40%', height: 'var(--percent100)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 'var(--pixel4)' }}>
						<Box sx={{ width: 'var(--percent100)', height: '32.9%' }}>
							{renderMedia(visibleMedia[1], 1)}
						</Box>
						<Box sx={{ width: 'var(--percent100)', height: '32.9%' }}>
							{renderMedia(visibleMedia[2], 2)}
						</Box>
						<Box sx={{ width: 'var(--percent100)', height: '32.9%' }}>
							{renderMedia(visibleMedia[3], 3)}
						</Box>
					</Box>
				</Box>
			);
		}
		else if (visibleMedia?.length === 5)
		{
			return (
				<Box sx={{ display: 'flex', width: 'var(--percent100)', height: 'var(--percent100)', gap: 'var(--pixel4)' }}>
					<Box sx={{ width: '60%', height: 'var(--percent100)' }}>
						{renderMedia(visibleMedia[0], 0)}
					</Box>
					<Box sx={{ width: '40%', height: 'var(--percent100)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 'var(--pixel4)' }}>
						<Box sx={{ width: 'var(--percent100)', height: '32.9%' }}>
							{renderMedia(visibleMedia[1], 1)}
						</Box>
						<Box sx={{ width: 'var(--percent100)', height: '32.9%' }}>
							{renderMedia(visibleMedia[2], 2)}
						</Box>
						<Box sx={{ display: 'flex', width: 'var(--percent100)', height: '32.9%', justifyContent: 'space-between' }}>
							<Box sx={{ width: 'calc(50% - 2px)', height: 'var(--percent100)' }}>
								{renderMedia(visibleMedia[3], 3)}
							</Box>
							<Box sx={{ width: 'calc(50% - 2px)', height: 'var(--percent100)' }}>
								{renderMedia(visibleMedia[4], 4)}
							</Box>
						</Box>

					</Box>
				</Box>
			);
		}
	};

	return (
		<>
			<Grid
				item
				xs={12}
				sx={{
					width       : 'var(--percent100)', // Takes full width of the container
					aspectRatio : smallIcons ? '16 / 6' : '16 / 9', // Sets height automatically based on aspect ratio
					objectFit   : 'cover',
					position    : 'relative'
				}}
				mt={2}
			>
				{renderMediaItems()}
			</Grid>
			{from === 'repost' && currentIndex >= 0 && open &&
			<MediaPreview
				key={currentIndex}
				open={currentIndex >= 0}
				mediaList={mediaData}
				openVideo={open}
				handleClose={() => { setCurrentIndex(0); setOpen(false); }}
				currentIndex={currentIndex}
				setCurrentIndex={setCurrentIndex}
			/>
			}
			{from !== 'repost' && (preLoad || (currentIndex >= 0 && open)) && ReactDOM.createPortal(
				<FeedFullView
					feedId={feed?._id}
					from={from}
					openVideo={open}
					handleUpdateFeed={handleUpdateFeed}
					handleClosePost={() => { setCurrentIndex(0); setOpen(false); }}
					feed={feed}
					mediaData={mediaData}
					setViewData={() => {}}
					Like={() => {}}
					currentIndex={currentIndex}
					setCurrentIndex={setCurrentIndex}
					getLatestFeed={undefined} // not required
					isInViewPort={preLoad}
				/>
				, document.body)}

		</>
	);
};

export default FeedMediaView;
